import React from 'react';

import { useNavigate, useLocation } from 'react-router-dom';

const ExternalRedirect = ({ link }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const params = new URLSearchParams(location.search);
  const destination = params.get('app');
  const token = params.get('token');
  const refreshToken = params.get('refresh');

  if (!token || !refreshToken) {
    navigate('/landing');
  }
  if (destination === '/admin') {
    // Go to external link
    window.location.href = `${link}/token?token=${token}&refresh=${refreshToken}`;
    return '';
  }
  navigate(destination ?? `/token?token=${token}&refresh=${refreshToken}`);
  return '';
};

export default ExternalRedirect;
